import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  start: 'Start',
  sessionError: 'Failed to start session',
});
